(function () {
var $1dcdcd4bb5744dba$var$i = Symbol.for("preact-signals");
function $1dcdcd4bb5744dba$var$t() {
    if (!($1dcdcd4bb5744dba$var$s > 1)) {
        var i, t = !1;
        while(void 0 !== $1dcdcd4bb5744dba$var$h){
            var r = $1dcdcd4bb5744dba$var$h;
            $1dcdcd4bb5744dba$var$h = void 0;
            $1dcdcd4bb5744dba$var$f++;
            while(void 0 !== r){
                var o = r.o;
                r.o = void 0;
                r.f &= -3;
                if (!(8 & r.f) && $1dcdcd4bb5744dba$var$c(r)) try {
                    r.c();
                } catch (r) {
                    if (!t) {
                        i = r;
                        t = !0;
                    }
                }
                r = o;
            }
        }
        $1dcdcd4bb5744dba$var$f = 0;
        $1dcdcd4bb5744dba$var$s--;
        if (t) throw i;
    } else $1dcdcd4bb5744dba$var$s--;
}
function $1dcdcd4bb5744dba$export$712ea50be43a7858(i) {
    if ($1dcdcd4bb5744dba$var$s > 0) return i();
    $1dcdcd4bb5744dba$var$s++;
    try {
        return i();
    } finally{
        $1dcdcd4bb5744dba$var$t();
    }
}
var $1dcdcd4bb5744dba$var$o = void 0;
function $1dcdcd4bb5744dba$export$8c437e4d572e2f99(i) {
    var t = $1dcdcd4bb5744dba$var$o;
    $1dcdcd4bb5744dba$var$o = void 0;
    try {
        return i();
    } finally{
        $1dcdcd4bb5744dba$var$o = t;
    }
}
var $1dcdcd4bb5744dba$var$h = void 0, $1dcdcd4bb5744dba$var$s = 0, $1dcdcd4bb5744dba$var$f = 0, $1dcdcd4bb5744dba$var$v = 0;
function $1dcdcd4bb5744dba$var$e(i) {
    if (void 0 !== $1dcdcd4bb5744dba$var$o) {
        var t = i.n;
        if (void 0 === t || t.t !== $1dcdcd4bb5744dba$var$o) {
            t = {
                i: 0,
                S: i,
                p: $1dcdcd4bb5744dba$var$o.s,
                n: void 0,
                t: $1dcdcd4bb5744dba$var$o,
                e: void 0,
                x: void 0,
                r: t
            };
            if (void 0 !== $1dcdcd4bb5744dba$var$o.s) $1dcdcd4bb5744dba$var$o.s.n = t;
            $1dcdcd4bb5744dba$var$o.s = t;
            i.n = t;
            if (32 & $1dcdcd4bb5744dba$var$o.f) i.S(t);
            return t;
        } else if (-1 === t.i) {
            t.i = 0;
            if (void 0 !== t.n) {
                t.n.p = t.p;
                if (void 0 !== t.p) t.p.n = t.n;
                t.p = $1dcdcd4bb5744dba$var$o.s;
                t.n = void 0;
                $1dcdcd4bb5744dba$var$o.s.n = t;
                $1dcdcd4bb5744dba$var$o.s = t;
            }
            return t;
        }
    }
}
function $1dcdcd4bb5744dba$export$8210dfe1863c478(i) {
    this.v = i;
    this.i = 0;
    this.n = void 0;
    this.t = void 0;
}
$1dcdcd4bb5744dba$export$8210dfe1863c478.prototype.brand = $1dcdcd4bb5744dba$var$i;
$1dcdcd4bb5744dba$export$8210dfe1863c478.prototype.h = function() {
    return !0;
};
$1dcdcd4bb5744dba$export$8210dfe1863c478.prototype.S = function(i) {
    if (this.t !== i && void 0 === i.e) {
        i.x = this.t;
        if (void 0 !== this.t) this.t.e = i;
        this.t = i;
    }
};
$1dcdcd4bb5744dba$export$8210dfe1863c478.prototype.U = function(i) {
    if (void 0 !== this.t) {
        var t = i.e, r = i.x;
        if (void 0 !== t) {
            t.x = r;
            i.e = void 0;
        }
        if (void 0 !== r) {
            r.e = t;
            i.x = void 0;
        }
        if (i === this.t) this.t = r;
    }
};
$1dcdcd4bb5744dba$export$8210dfe1863c478.prototype.subscribe = function(i) {
    var t = this;
    return $1dcdcd4bb5744dba$export$dc573d8a6576cdb3(function() {
        var r = t.value, n = $1dcdcd4bb5744dba$var$o;
        $1dcdcd4bb5744dba$var$o = void 0;
        try {
            i(r);
        } finally{
            $1dcdcd4bb5744dba$var$o = n;
        }
    });
};
$1dcdcd4bb5744dba$export$8210dfe1863c478.prototype.valueOf = function() {
    return this.value;
};
$1dcdcd4bb5744dba$export$8210dfe1863c478.prototype.toString = function() {
    return this.value + "";
};
$1dcdcd4bb5744dba$export$8210dfe1863c478.prototype.toJSON = function() {
    return this.value;
};
$1dcdcd4bb5744dba$export$8210dfe1863c478.prototype.peek = function() {
    var i = $1dcdcd4bb5744dba$var$o;
    $1dcdcd4bb5744dba$var$o = void 0;
    try {
        return this.value;
    } finally{
        $1dcdcd4bb5744dba$var$o = i;
    }
};
Object.defineProperty($1dcdcd4bb5744dba$export$8210dfe1863c478.prototype, "value", {
    get: function() {
        var i = $1dcdcd4bb5744dba$var$e(this);
        if (void 0 !== i) i.i = this.i;
        return this.v;
    },
    set: function(i) {
        if (i !== this.v) {
            if ($1dcdcd4bb5744dba$var$f > 100) throw new Error("Cycle detected");
            this.v = i;
            this.i++;
            $1dcdcd4bb5744dba$var$v++;
            $1dcdcd4bb5744dba$var$s++;
            try {
                for(var r = this.t; void 0 !== r; r = r.x)r.t.N();
            } finally{
                $1dcdcd4bb5744dba$var$t();
            }
        }
    }
});
function $1dcdcd4bb5744dba$export$e2ef10f86a8d60e8(i) {
    return new $1dcdcd4bb5744dba$export$8210dfe1863c478(i);
}
function $1dcdcd4bb5744dba$var$c(i) {
    for(var t = i.s; void 0 !== t; t = t.n)if (t.S.i !== t.i || !t.S.h() || t.S.i !== t.i) return !0;
    return !1;
}
function $1dcdcd4bb5744dba$var$a(i) {
    for(var t = i.s; void 0 !== t; t = t.n){
        var r = t.S.n;
        if (void 0 !== r) t.r = r;
        t.S.n = t;
        t.i = -1;
        if (void 0 === t.n) {
            i.s = t;
            break;
        }
    }
}
function $1dcdcd4bb5744dba$var$l(i) {
    var t = i.s, r = void 0;
    while(void 0 !== t){
        var o = t.p;
        if (-1 === t.i) {
            t.S.U(t);
            if (void 0 !== o) o.n = t.n;
            if (void 0 !== t.n) t.n.p = o;
        } else r = t;
        t.S.n = t.r;
        if (void 0 !== t.r) t.r = void 0;
        t = o;
    }
    i.s = r;
}
function $1dcdcd4bb5744dba$var$y(i) {
    $1dcdcd4bb5744dba$export$8210dfe1863c478.call(this, void 0);
    this.x = i;
    this.s = void 0;
    this.g = $1dcdcd4bb5744dba$var$v - 1;
    this.f = 4;
}
($1dcdcd4bb5744dba$var$y.prototype = new $1dcdcd4bb5744dba$export$8210dfe1863c478).h = function() {
    this.f &= -3;
    if (1 & this.f) return !1;
    if (32 == (36 & this.f)) return !0;
    this.f &= -5;
    if (this.g === $1dcdcd4bb5744dba$var$v) return !0;
    this.g = $1dcdcd4bb5744dba$var$v;
    this.f |= 1;
    if (this.i > 0 && !$1dcdcd4bb5744dba$var$c(this)) {
        this.f &= -2;
        return !0;
    }
    var i = $1dcdcd4bb5744dba$var$o;
    try {
        $1dcdcd4bb5744dba$var$a(this);
        $1dcdcd4bb5744dba$var$o = this;
        var t = this.x();
        if (16 & this.f || this.v !== t || 0 === this.i) {
            this.v = t;
            this.f &= -17;
            this.i++;
        }
    } catch (i) {
        this.v = i;
        this.f |= 16;
        this.i++;
    }
    $1dcdcd4bb5744dba$var$o = i;
    $1dcdcd4bb5744dba$var$l(this);
    this.f &= -2;
    return !0;
};
$1dcdcd4bb5744dba$var$y.prototype.S = function(i) {
    if (void 0 === this.t) {
        this.f |= 36;
        for(var t = this.s; void 0 !== t; t = t.n)t.S.S(t);
    }
    $1dcdcd4bb5744dba$export$8210dfe1863c478.prototype.S.call(this, i);
};
$1dcdcd4bb5744dba$var$y.prototype.U = function(i) {
    if (void 0 !== this.t) {
        $1dcdcd4bb5744dba$export$8210dfe1863c478.prototype.U.call(this, i);
        if (void 0 === this.t) {
            this.f &= -33;
            for(var t = this.s; void 0 !== t; t = t.n)t.S.U(t);
        }
    }
};
$1dcdcd4bb5744dba$var$y.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 6;
        for(var i = this.t; void 0 !== i; i = i.x)i.t.N();
    }
};
Object.defineProperty($1dcdcd4bb5744dba$var$y.prototype, "value", {
    get: function() {
        if (1 & this.f) throw new Error("Cycle detected");
        var i = $1dcdcd4bb5744dba$var$e(this);
        this.h();
        if (void 0 !== i) i.i = this.i;
        if (16 & this.f) throw this.v;
        return this.v;
    }
});
function $1dcdcd4bb5744dba$export$2983e091f1a1e8e2(i) {
    return new $1dcdcd4bb5744dba$var$y(i);
}
function $1dcdcd4bb5744dba$var$_(i) {
    var r = i.u;
    i.u = void 0;
    if ("function" == typeof r) {
        $1dcdcd4bb5744dba$var$s++;
        var n = $1dcdcd4bb5744dba$var$o;
        $1dcdcd4bb5744dba$var$o = void 0;
        try {
            r();
        } catch (t) {
            i.f &= -2;
            i.f |= 8;
            $1dcdcd4bb5744dba$var$g(i);
            throw t;
        } finally{
            $1dcdcd4bb5744dba$var$o = n;
            $1dcdcd4bb5744dba$var$t();
        }
    }
}
function $1dcdcd4bb5744dba$var$g(i) {
    for(var t = i.s; void 0 !== t; t = t.n)t.S.U(t);
    i.x = void 0;
    i.s = void 0;
    $1dcdcd4bb5744dba$var$_(i);
}
function $1dcdcd4bb5744dba$var$p(i) {
    if ($1dcdcd4bb5744dba$var$o !== this) throw new Error("Out-of-order effect");
    $1dcdcd4bb5744dba$var$l(this);
    $1dcdcd4bb5744dba$var$o = i;
    this.f &= -2;
    if (8 & this.f) $1dcdcd4bb5744dba$var$g(this);
    $1dcdcd4bb5744dba$var$t();
}
function $1dcdcd4bb5744dba$var$b(i) {
    this.x = i;
    this.u = void 0;
    this.s = void 0;
    this.o = void 0;
    this.f = 32;
}
$1dcdcd4bb5744dba$var$b.prototype.c = function() {
    var i = this.S();
    try {
        if (8 & this.f) return;
        if (void 0 === this.x) return;
        var t = this.x();
        if ("function" == typeof t) this.u = t;
    } finally{
        i();
    }
};
$1dcdcd4bb5744dba$var$b.prototype.S = function() {
    if (1 & this.f) throw new Error("Cycle detected");
    this.f |= 1;
    this.f &= -9;
    $1dcdcd4bb5744dba$var$_(this);
    $1dcdcd4bb5744dba$var$a(this);
    $1dcdcd4bb5744dba$var$s++;
    var i = $1dcdcd4bb5744dba$var$o;
    $1dcdcd4bb5744dba$var$o = this;
    return $1dcdcd4bb5744dba$var$p.bind(this, i);
};
$1dcdcd4bb5744dba$var$b.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 2;
        this.o = $1dcdcd4bb5744dba$var$h;
        $1dcdcd4bb5744dba$var$h = this;
    }
};
$1dcdcd4bb5744dba$var$b.prototype.d = function() {
    this.f |= 8;
    if (!(1 & this.f)) $1dcdcd4bb5744dba$var$g(this);
};
function $1dcdcd4bb5744dba$export$dc573d8a6576cdb3(i) {
    var t = new $1dcdcd4bb5744dba$var$b(i);
    try {
        t.c();
    } catch (i) {
        t.d();
        throw i;
    }
    return t.d.bind(t);
}


const $2d081a1fa49e40a2$var$tests = document.getElementById("tests").children; // 测试题目列表
const $2d081a1fa49e40a2$var$alignments = document.getElementById("alignments").children; // 结果列表
const $2d081a1fa49e40a2$var$progress = document.getElementById("progress"); // 进度条
const $2d081a1fa49e40a2$var$prev = document.getElementById("prev"); // 上一题按钮
// 测试题目总数
const $2d081a1fa49e40a2$var$total = $2d081a1fa49e40a2$var$tests.length;
$2d081a1fa49e40a2$var$progress.setAttribute("max", ($2d081a1fa49e40a2$var$total - 1).toString());
// 选项随机排列
for (const test of $2d081a1fa49e40a2$var$tests){
    const options = Array.from(test.children).slice(1);
    const shuffled = Array.from(options).sort(()=>Math.random() - 0.5);
    for (const option of shuffled)test.appendChild(option);
}
// 当前测试题目索引
const $2d081a1fa49e40a2$var$current = (0, $1dcdcd4bb5744dba$export$e2ef10f86a8d60e8)(0);
// 当前完成的测试数量
const $2d081a1fa49e40a2$var$completed = (0, $1dcdcd4bb5744dba$export$e2ef10f86a8d60e8)(0);
// 当前显示的测试题目索引
let $2d081a1fa49e40a2$var$active = null;
// 当前测试题目索引变化时，更新显示的测试题目
(0, $1dcdcd4bb5744dba$export$dc573d8a6576cdb3)(()=>{
    if ($2d081a1fa49e40a2$var$active !== null) $2d081a1fa49e40a2$var$tests[$2d081a1fa49e40a2$var$active].classList.remove("active");
    $2d081a1fa49e40a2$var$active = $2d081a1fa49e40a2$var$current.value;
    $2d081a1fa49e40a2$var$tests[$2d081a1fa49e40a2$var$active].classList.add("active");
    $2d081a1fa49e40a2$var$progress.setAttribute("value", $2d081a1fa49e40a2$var$active.toString());
});
// 作答后
document.querySelectorAll('input[type="radio"]').forEach((radio)=>{
    radio.addEventListener("change", ()=>{
        // 自动跳转到下一题
        if ($2d081a1fa49e40a2$var$current.value < $2d081a1fa49e40a2$var$total - 1) setTimeout(()=>$2d081a1fa49e40a2$var$current.value++, 350);
        // 更新已完成的测试数量
        $2d081a1fa49e40a2$var$completed.value = document.querySelectorAll('input[type="radio"]:checked').length;
        // 显示测试结果(如果所有测试都已完成)
        $2d081a1fa49e40a2$var$showResult();
    });
});
// 点击上一题
$2d081a1fa49e40a2$var$prev.addEventListener("click", ()=>{
    if ($2d081a1fa49e40a2$var$current.value > 0) $2d081a1fa49e40a2$var$current.value--;
});
// 如果当前是第一题，则隐藏上一题按钮
(0, $1dcdcd4bb5744dba$export$dc573d8a6576cdb3)(()=>{
    $2d081a1fa49e40a2$var$prev.style.display = $2d081a1fa49e40a2$var$current.value > 0 ? "block" : "none";
});
// 显示测试结果
function $2d081a1fa49e40a2$var$showResult() {
    if ($2d081a1fa49e40a2$var$completed.value < $2d081a1fa49e40a2$var$total) return;
    const affects = {
        "cx": 0,
        "lx": 0,
        "nx": 0,
        "xe": 0,
        "xg": 0,
        "xn": 0 // neutral (e vs g)
    };
    document.querySelectorAll('input[type="radio"]:checked').forEach((radio)=>{
        const infl = radio.getAttribute("data-infl");
        const value = parseInt(radio.getAttribute("data-value"));
        affects[infl] += value;
    });
    let maxScore = 0;
    let maxAlignment = "";
    for (const alignment of $2d081a1fa49e40a2$var$alignments){
        const tag = alignment.getAttribute("data-alignment");
        const lawful = affects[tag[0] + "x"];
        const good = affects["x" + tag[1]];
        const score = lawful + good;
        if (score > maxScore) {
            maxScore = score;
            maxAlignment = tag;
        }
    }
    for (const alignment of $2d081a1fa49e40a2$var$alignments)if (alignment.getAttribute("data-alignment") === maxAlignment) alignment.classList.add("active");
    else alignment.classList.remove("active");
}
(0, $1dcdcd4bb5744dba$export$dc573d8a6576cdb3)($2d081a1fa49e40a2$var$showResult);

})();
//# sourceMappingURL=index.0605a4dc.js.map
